import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "text-[34px] h-11 leading-11 font-bold mb-4" }, "Настройки", -1)
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "mr-4" }
const _hoisted_4 = { class: "text-xl font-bold" }
const _hoisted_5 = { class: "text-xs text-gray-400" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Выйти из аккаунта ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Версия приложения", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-400" }, "10 февраля 2025 г.", -1)

import { ref, watch } from "vue";
import { RouteRecordRaw } from "vue-router";

import { settingsRoutes } from "@/router/routes";
import { useStore } from "@/use/useStore";
import { usePermissions } from "@/use/usePermissions";

import UiApp from "@/plugins/ui/components/app/UiApp.vue";
import UiBtn from "@/plugins/ui/components/button/UiBtn.vue";
import UiCard from "@/plugins/ui/components/card/UiCard.vue";
import UiCell from "@/plugins/ui/components/cell/UiCell.vue";

import UiAppBar from "@/components/UiAppBar.vue";
import UiIcon from "@/components/ui/UiIcon.vue";

import AccountSelect from "@/components/AccountSelect.vue";
import AppSidebar from "@/components/AppSidebar.vue";
import UiHeader from "@/plugins/ui/components/header/UiHeader.vue";
import AppTopBar from "@/components/AppTopBar.vue";
import UiGroup from "@/plugins/ui/components/group/UiGroup.vue";
import UiAppbar from "@/plugins/ui/components/appbar/UiAppbar.vue";
import UiAppbarButton from "@/plugins/ui/components/appbar/UiAppbarButton.vue";
import AppTabbar from "@/components/AppTabbar.vue";
import AvailableModules from "@/components/AvailableModules.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Settings',
  setup(__props) {

const { currentUser } = useStore();
const { isAllow } = usePermissions();

const availableRoutes = ref<RouteRecordRaw[]>([]);

function calculateRoutes() {
  availableRoutes.value = settingsRoutes.filter((route) => {
    if (route.meta?.hidden === true) {
      return;
    }
    return route.meta?.allowFor ? isAllow(route.meta.allowFor) : true;
  });
}

watch(() => currentUser.value?.id, calculateRoutes, { immediate: true });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(UiApp, null, {
    header: _withCtx(() => [
      _createVNode(UiAppbar, {
        temporary: "",
        title: "Настройки"
      })
    ]),
    sidebar: _withCtx(() => [
      _createVNode(AppSidebar)
    ]),
    footer: _withCtx(() => [
      _createVNode(AppTabbar)
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(UiGroup, null, {
        default: _withCtx(() => [
          _createVNode(UiCard, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("h3", _hoisted_4, _toDisplayString(_unref(currentUser)?.surname) + " " + _toDisplayString(_unref(currentUser)?.name) + " " + _toDisplayString(_unref(currentUser)?.description), 1),
                  _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(currentUser)?.school?.full_name), 1)
                ]),
                _createVNode(AccountSelect)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(UiGroup, null, {
        header: _withCtx(() => [
          _createVNode(UiHeader, { title: "Аккаунт" })
        ]),
        default: _withCtx(() => [
          _createVNode(UiCard, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableRoutes.value, (route) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: route.path,
                  to: { name: route.name },
                  custom: ""
                }, {
                  default: _withCtx(({ navigate }) => [
                    _createVNode(UiCell, {
                      onClick: ($event: any) => (navigate())
                    }, {
                      left: _withCtx(() => [
                        (route.meta?.icon)
                          ? (_openBlock(), _createBlock(UiIcon, {
                              key: 0,
                              icon: route.meta.icon
                            }, null, 8, ["icon"]))
                          : _createCommentVNode("", true)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(route.meta?.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128)),
              _createVNode(_component_router_link, {
                to: "/login",
                custom: ""
              }, {
                default: _withCtx(({ navigate }) => [
                  _createVNode(UiCell, {
                    onClick: ($event: any) => (navigate())
                  }, {
                    left: _withCtx(() => [
                      _createVNode(UiIcon, { icon: "Logout" })
                    ]),
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(UiGroup, null, {
        header: _withCtx(() => [
          _createVNode(UiHeader, { title: "О приложении" })
        ]),
        default: _withCtx(() => [
          _createVNode(UiCard, null, {
            default: _withCtx(() => [
              _createVNode(UiCell, null, {
                left: _withCtx(() => [
                  _createVNode(UiIcon, { icon: "InformationCircle" })
                ]),
                default: _withCtx(() => [
                  _hoisted_7,
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(AvailableModules, { type: "unsupported" })
    ]),
    _: 1
  }))
}
}

})